import { render, staticRenderFns } from "./HeaderNotification.vue?vue&type=template&id=4d4cbf64&scoped=true&"
import script from "./HeaderNotification.vue?vue&type=script&lang=js&"
export * from "./HeaderNotification.vue?vue&type=script&lang=js&"
import style0 from "./HeaderNotification.vue?vue&type=style&index=0&id=4d4cbf64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4cbf64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d4cbf64')) {
      api.createRecord('4d4cbf64', component.options)
    } else {
      api.reload('4d4cbf64', component.options)
    }
    module.hot.accept("./HeaderNotification.vue?vue&type=template&id=4d4cbf64&scoped=true&", function () {
      api.rerender('4d4cbf64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/HeaderNotification.vue"
export default component.exports